"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get formatDuration () {
        return _formatDuration.formatDuration;
    },
    get hrToSeconds () {
        return _formatDuration.hrToSeconds;
    },
    get hrtimeDiff () {
        return _formatDuration.hrtimeDiff;
    }
});
const _formatDuration = require("./formatDuration.js");
